module.exports = __webpack_public_path__ + "img/advantage4@2x.587e320b.png";